import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { registerPushServiceWorker } from './services/push';
import './index.css'; // Importante: Importar o CSS para o Vite processar o Tailwind

const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  void registerPushServiceWorker();
} else {
  console.error("ERRO CRÍTICO: Elemento #root não encontrado no DOM.");
}
